import React, { FC } from 'react';
import { useGetInfinityGroupsOfSecretCodes } from '@services/drop/hooks/useGetGroupsOfSecretCodes';
import { GeneratedCodesCard } from '@components/Cards/GeneratedCodesCard/GeneratedCodesCard';
import { toy } from '@prisma/client';
import { useGetArtistDropsList } from '@services/artist/hooks/useGetArtistDrops';
import { useTranslation } from '@hooks/useTranslation';
import { GeneratedCodesCardLoading } from '@components/Cards/GeneratedCodesCard/GeneratedCodesCardLoading';
import { InfinityListWithSkeleton } from '@components/InfinityList/InfinityListWithSkeleton';
import { Button } from '@components/UIKit/Button/Button';
import { LinksEnum } from '@specs/navigation';
import { useRouter } from 'next/router';
import { InViewHookResponse } from 'react-intersection-observer';
import s from './list.module.scss';
interface Props {
  inView: InViewHookResponse['inView'];
  toyId: toy['id'];
  slug: toy['slug'];
  name: toy['name'];
  onlyOneFetch: boolean;
}
const limit = 5;
export const List: FC<Props> = ({
  name,
  slug,
  toyId,
  onlyOneFetch,
  inView
}) => {
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  const {
    data: drops,
    isLoading
  } = useGetArtistDropsList({
    limit: 1,
    mechanic: 'SECRET_PERSONAL',
    toyId
  }, {
    enabled: inView
  });
  const dropId = drops?.items?.[0]?.id;
  const {
    data,
    status,
    hasNextPage,
    fetchNextPage
  } = useGetInfinityGroupsOfSecretCodes({
    dropId: dropId ?? -1,
    limit
  }, {
    enabled: typeof dropId === 'number'
  });
  const clickHandler = async () => {
    await router.push({
      pathname: LinksEnum.TOY_GENERATED_CODES,
      query: {
        slug
      }
    });
  };
  return <>
            <InfinityListWithSkeleton data={data} enabledRef={undefined} status={isLoading ? 'loading' : status} hasNextPage={onlyOneFetch ? false : hasNextPage} fetchNextPage={onlyOneFetch ? () => {} : fetchNextPage} EmptyComponent={() => <div className={s.list__empty}>{tr({
        id: 'toy.page.generated.codes.empty.text'
      })}</div>} loader={Array.from(Array(limit).keys()).map(item => <GeneratedCodesCardLoading key={item} />)} data-sentry-element="InfinityListWithSkeleton" data-sentry-source-file="List.tsx">
                {(item, _, pageIndex) => {
        if (pageIndex > 0 && onlyOneFetch) return;
        return <GeneratedCodesCard key={item.id} {...item} toyName={name} toySlug={slug} />;
      }}
            </InfinityListWithSkeleton>
            {(hasNextPage || (data?.pages?.length ?? 0) > 1) && onlyOneFetch && <Button id='generate_codes_view_all_button' color={'Transparent'} size={'medium'} onClick={clickHandler}>
                    {tr({
        id: 'btn.view.all'
      })}
                </Button>}
        </>;
};